/* ============================================================
   BROKEN WILLOW — Shopify Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Scroll-reveal (Intersection Observer) ---- */
  const revealEls = document.querySelectorAll('.reveal, .line-reveal');
  if (revealEls.length) {
    const revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
    );
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---- Sticky nav ---- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ---- Mobile menu toggle ---- */
  var burger = document.querySelector('.site-header__burger');
  if (burger && header) {
    burger.addEventListener('click', function () {
      header.classList.toggle('menu-open');
      var expanded = header.classList.contains('menu-open');
      burger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
    // Close on link click
    var mobileLinks = document.querySelectorAll('.site-header__mobile-menu a');
    mobileLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        header.classList.remove('menu-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---- Hero parallax ---- */
  var heroBg = document.querySelector('.hero__bg');
  var heroContent = document.querySelector('.hero__content');
  if (heroBg) {
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      heroBg.style.transform = 'translateY(' + (scrollY * 0.2) + 'px)';
      if (heroContent) {
        heroContent.style.opacity = Math.max(0, 1 - scrollY / 400);
        heroContent.style.transform = 'translateY(' + (scrollY * 0.2) + 'px)';
      }
    }, { passive: true });
  }

  /* ---- Testimonials slider ---- */
  var slides = document.querySelectorAll('.testimonial-slide');
  var dots   = document.querySelectorAll('.testimonial-dot');
  if (slides.length > 1) {
    var currentSlide = 0;
    function showSlide(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('active', i === index);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === index);
      });
      currentSlide = index;
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { showSlide(i); });
    });
    setInterval(function () {
      showSlide((currentSlide + 1) % slides.length);
    }, 5000);
  }

  /* ---- Product detail tabs ---- */
  document.querySelectorAll('.product-tabs__nav').forEach(function (nav) {
    var tabBtns   = nav.querySelectorAll('.product-tab-btn');
    var tabSection = nav.closest('.section-product-detail__content') || nav.parentElement;
    var tabPanels = tabSection ? tabSection.querySelectorAll('.product-tab-panel') : [];
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.tab;
        tabBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        tabPanels.forEach(function (panel) {
          panel.classList.toggle('active', panel.dataset.tab === target);
        });
      });
    });
  });

  /* ---- Accordion (herb education FAQ) ---- */
  document.querySelectorAll('.accordion-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var item = toggle.closest('.accordion-item');
      var isOpen = item.classList.contains('open');
      // Close all siblings
      var siblings = item.parentElement.querySelectorAll('.accordion-item');
      siblings.forEach(function (s) { s.classList.remove('open'); });
      // Toggle clicked
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ---- Size selector (body butter, deodorant) ---- */
  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.size-selector');
      if (group) {
        group.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      }
      btn.classList.add('active');
      var priceEl = btn.closest('.section-product-detail__content').querySelector('[data-size-price]');
      var unitEl  = btn.closest('.section-product-detail__content').querySelector('[data-size-unit]');
      if (priceEl) priceEl.textContent = '$' + btn.dataset.price;
      if (unitEl)  unitEl.textContent  = btn.dataset.unit;
    });
  });

  /* ---- AJAX Add to Cart ---- */
  var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.add-to-cart-btn');
      if (btn) {
        btn.textContent = 'Adding…';
        btn.disabled = true;
      }
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (btn) {
          btn.textContent = 'Added!';
          setTimeout(function () {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }, 2000);
        }
        updateCartCount();
      })
      .catch(function () {
        if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var countEl = document.querySelector('.cart-count-badge');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      }
    });
  }
  updateCartCount();

  /* ---- Cart quantity adjustments ---- */
  document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.key;
      var delta = parseInt(btn.dataset.delta, 10);
      var qtyEl = document.querySelector('[data-qty-key="' + key + '"]');
      if (!qtyEl) return;
      var newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + delta);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(function () { location.reload(); });
    });
  });

  /* ---- Custom package builder (multi-step form) ---- */
  var builderForm = document.querySelector('.package-builder');
  if (builderForm) {
    var steps = builderForm.querySelectorAll('.builder-step');
    var nextBtns = builderForm.querySelectorAll('[data-next-step]');
    var backBtns = builderForm.querySelectorAll('[data-back-step]');
    var stepIndicators = builderForm.querySelectorAll('.step-indicator');
    var currentStep = 1;

    function showStep(n) {
      steps.forEach(function (s, i) {
        s.style.display = i + 1 === n ? 'block' : 'none';
      });
      stepIndicators.forEach(function (ind, i) {
        ind.classList.toggle('active', i + 1 === n);
      });
      currentStep = n;
    }
    showStep(1);

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(parseInt(btn.dataset.nextStep, 10));
      });
    });
    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(parseInt(btn.dataset.backStep, 10));
      });
    });

    // Concern toggles
    builderForm.querySelectorAll('.concern-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('selected');
        var anySelected = builderForm.querySelectorAll('.concern-btn.selected').length > 0;
        var nextBtn = builderForm.querySelector('[data-next-step="2"]');
        if (nextBtn) nextBtn.disabled = !anySelected;
      });
    });

    // Submission
    var submitForm = builderForm.querySelector('.package-submit-form');
    if (submitForm) {
      submitForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var success = builderForm.querySelector('.builder-success');
        var form    = builderForm.querySelector('.builder-step-3');
        if (success) { success.style.display = 'block'; }
        if (form)    { form.style.display    = 'none'; }
        var stepNav = builderForm.querySelector('.builder-step-nav');
        if (stepNav) stepNav.style.display = 'none';
      });
    }
  }

  /* ---- Connect consultation form (Shopify contact form) ---- */
  var connectForm = document.querySelector('.contact-form');
  if (connectForm) {
    // Native Shopify contact form submission — allow default
  }

});
